import React , { useState }from 'react'

import { ApiCallPost } from '../ApiCall/ApiCall';
import { useNavigate  } from "react-router-dom";

import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner'




function SignUp2() {
    const [passValue,setPassValue] = useState( "")
    //const [logError,setLoggError] = useState( false )
    const [inputError,setInputError] = useState( false )
    const [reenter,setReenter] = useState( false)
    //const [password1,setPassword1] = useState( "" )
    const [password2,setPassword2] = useState( "" ) 
    const [passError,setPassError] = useState( "" ) ;
    const [isAdding,setIsAdding] = useState( "" ) ;
    const [yaExiste,setYaExiste] = useState( false) ;
    const [messageError,setMessageError] = useState( "" ) ;
    const [isSuccess,setIsSuccess] = useState( false ) ;

    const navigate = useNavigate() ;

    function setLogin()
    {
        navigate( "/") ; 
    }

    function showReenter()
    {
        setReenter( true )
    }

    function getReenter()
    {
        var retVal = <div className="flex md:w-12 flex-wrap align-items-center gap-2">
        <label className="w-50
        ">Reenter Password</label> 
        <Password className="w-75"  onBlur={()=> setReenter( false )}
        onFocus={() => setInputError(false)}
        value={password2} onChange={(e) => setPassValue2(e.target.value)} style={{border:'1px solid', borderColor : 'purple'}}
        id='reenter' 
        promptLabel="Teclee un Password" weakLabel="Muy simple" mediumLabel="Complejidad Mediana" strongLabel="Password Complejo" toggleMask />
        </div>

        return retVal ;
    }

    function setPassValue2(val)
    {
        console.log( "Password = " + passValue + "  pass2 = " + val )

        setPassword2( val )

        if ( val !== passValue )
        {
            setPassError( true )
            
        }
        else{
            setPassError( false )
        }
    }

    function onAddUser()
    {
        console.log( "Se solicita agregar usuario")

        var email = document.getElementById( 'email').value ;
        var password = document.getElementById( 'password' ).value ;
        var nombre = document.getElementById("nombre").value ; 
        var telefono = document.getElementById("telefono").value ;

        telefono = telefono.replaceAll( "-" , "")

        if ( email === "" || password === "" || nombre === ""  || telefono === "" )
        {
            setMessageError( "No se capturaron todos los campos") ;
            setInputError( true )

            return ;
        }

        const persona = {
            "user": email ,
            "password": password ,
            "nombre": nombre ,
            "telefono": telefono ,
            "role": 4 ,
            "dTimeStamp": new Date()
        }

        console.log( "Antes del post " , persona )

        //return ;

        ApiCallPost( 'adduser' , persona )
        .then( (response) => {

            if ( response !== 0 )
            {
                setMessageError( "El usuario ya existia en la base de datos") ;
                setInputError( true )
            }
            else{
                setIsSuccess( true ) ;
            }

        })
        .catch((err) => {

            console.log( "Error")

            setMessageError( "Error al acceder a la base de datos") ;
            setInputError( true )

        })
    }

  return (
    <div className='w-50 mt-5' style={{margin:'auto'}}>

        <div className=' text-center'>
            <h3>Alta de nuevo usuario</h3>
        </div>

        <div className="flex flex-columna md:flex-row">
            <div className="w-full md:w-7 flex flex-column align-items-center justify-content-center gap-3 py-5">

                <div className="flex md:w-12 flex-wrap align-items-center gap-2">
                    <label className="w-100">Correo</label>
                    <InputText id="email" onFocus={() => setInputError(false)}
                        placeholder="Email"  className="p-invalid mr-2" />
                    {/*<Message severity="error" text="Password es requerido" />*/}
                </div>

            
                <div className="flex md:w-12 flex-wrap align-items-center gap-2">
                        <label className="w-50
                        ">Password</label>
                        <Password className="w-75"  onFocus={() => setInputError(false)} onBlur={showReenter}
                            value={passValue} onChange={(e) => setPassValue(e.target.value)} style={{border:'1px solid', borderColor : 'purple'}}
                            id='password' 
                            promptLabel="Teclee un Password" weakLabel="Muy simple" mediumLabel="Complejidad Mediana" strongLabel="Password Complejo" toggleMask />
                    {/* <Message severity="error" text="Username is required" /> */}
                </div>

                {
                    reenter && (
                        
                            getReenter()
                        
                    )


                }
                {
                    passError && (
                        <Message severity="error" text="El password no coincide" />
                    )
                }


                <div className="flex md:w-12 flex-wrap align-items-center gap-2">
                    <label className="w-100">Nombre</label>
                    <InputText id="nombre" onFocus={() => setInputError(false)}
                        placeholder="nombre"  className="p-invalid mr-2" />
                    {/*<Message severity="error" text="Password es requerido" />*/}
                </div>

                <div className="flex md:w-12 flex-wrap align-items-center gap-2">
                    <label className="w-100">Telefono</label>
                    <InputMask id="telefono" mask="9999999999"
                        placeholder="9999999999"  className="p-invalid mr-2" />
                    {/*<Message severity="error" text="Password es requerido" />*/}
                </div>


                <Button label="Agregar Usuario" icon="pi pi-user-plus" onClick={onAddUser}
                        className="w-100 mx-auto"></Button>

                {
                    inputError && (
                        <Message onClick={setLogin} severity="error" text={messageError} />
                    )

                }

                {
                    isSuccess && (
                        <Message severity="success" onClick={setLogin}
                            text="Se agrego el registro con exito" />
                    )
                }

                {
                    isAdding && (
                        <ProgressSpinner></ProgressSpinner>
                    )

                }

                <Button label="Regresar" severity="secondary" icon="pi pi-user" onClick={setLogin}
                        className="w-100 mx-auto"></Button>
                
            </div>

 
        </div>
    </div>
  )
}

export default SignUp2